import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { Input, Table, Button } from 'reactstrap';
import Footer from '../../components/footer/Footer';
import Logo from '../../components/assets/omint-pride.svg';
import Header from '../../components/header/Header';
import { AgeStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import imageSource from '../../components/assets/idades-beneficiarios.webp';
import ProgressBar from '../../components/status/ProgressBar';
import videoSource from '../../components/assets/Video_forms.mp4';

const FaixasEtarias = [
  { Qtd: '00to18', IdFaixaEtaria: 1 },
  { Qtd: '19to23', IdFaixaEtaria: 2 },
  { Qtd: '24to28', IdFaixaEtaria: 3 },
  { Qtd: '29to33', IdFaixaEtaria: 4 },
  { Qtd: '34to38', IdFaixaEtaria: 5 },
  { Qtd: '39to43', IdFaixaEtaria: 6 },
  { Qtd: '44to48', IdFaixaEtaria: 7 },
  { Qtd: '49to53', IdFaixaEtaria: 8 },
  { Qtd: '54to58', IdFaixaEtaria: 9 },
  { Qtd: '59+', IdFaixaEtaria: 10 },
];

const FormAge = () => {
  const [progress, setProgress] = useState(3);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const [ageData, setAgeData] = useState({});

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleChange = (ageRange, idFaixaEtaria) => (e) => {
    let value = e.target.value.trim(); // Remove espaços em branco no início e no final
    value = value.slice(0, 3); // Limita a string aos primeiros 3 caracteres

    // Verifica se o valor é um número e se é maior que zero
    if (!isNaN(value) && parseInt(value, 10) >= 0) {
      setAgeData((prevData) => ({
        ...prevData,
        [ageRange]: { IdFaixaEtaria: idFaixaEtaria, Qtd: value },
      }));
    } else {
      // Limpa o campo se o valor não for um número válido
      setAgeData((prevData) => {
        const newData = { ...prevData };
        delete newData[ageRange];
        return newData;
      });
    }
  };

  const handleIncrement = (ageRange, idFaixaEtaria) => () => {
    setAgeData((prevData) => {
      const newValue = (
        parseInt(prevData[ageRange]?.Qtd || 0, 10) + 1
      ).toString();
      return {
        ...prevData,
        [ageRange]: { IdFaixaEtaria: idFaixaEtaria, Qtd: newValue },
      };
    });
  };

  const handleDecrement = (ageRange, idFaixaEtaria) => () => {
    setAgeData((prevData) => {
      const newValue = Math.max(
        0,
        parseInt(prevData[ageRange]?.Qtd || 0, 10) - 1,
      ).toString();
      return {
        ...prevData,
        [ageRange]: { IdFaixaEtaria: idFaixaEtaria, Qtd: newValue },
      };
    });
  };

  useEffect(() => {
    const dataToSave = Object.values(ageData);
    const total = dataToSave.reduce(
      (acc, curr) => acc + parseInt(curr.Qtd, 10),
      0,
    );

    sessionStorage.setItem('@ageData', JSON.stringify(dataToSave));
    sessionStorage.setItem('@ageTotal', total);
  }, [ageData]);

  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem('@ageData'));
    const savedTotal = sessionStorage.getItem('@ageTotal');
    if (savedData) {
      const restoredData = savedData.reduce((acc, curr) => {
        acc[curr.Qtd] = { IdFaixaEtaria: curr.IdFaixaEtaria, Qtd: curr.Qtd };
        return acc;
      }, {});
      setAgeData(restoredData);
    }
    if (savedTotal) {
      // Handle the saved total if needed
      // console.log('Total:', savedTotal);
    }
  }, []);

  const renderTable = () => (
    <Table bordered>
      <tbody>
        {FaixasEtarias.map((faixa) => (
          <tr key={faixa.Qtd}>
            <th scope="row">{faixa.Qtd.replace('to', ' a ')}</th>
            <td style={{ display: 'flex', alignItems: 'center' }}>
              <button
                className="btnAges"
                onClick={handleDecrement(faixa.Qtd, faixa.IdFaixaEtaria)}
              >
                -
              </button>
              <Input
                type="number"
                name={faixa.Qtd}
                value={ageData[faixa.Qtd]?.Qtd || ''}
                onChange={handleChange(faixa.Qtd, faixa.IdFaixaEtaria)}
                min="0"
                style={{ textAlign: 'center', margin: '0 10px' }}
              />
              <button
                className="btnAges"
                onClick={handleIncrement(faixa.Qtd, faixa.IdFaixaEtaria)}
              >
                +
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  return (
    <>
      <AgeStyle>
        <section className="formAge">
          <div className="logo-wrapper">
            <img className="logo-img" src={Logo} alt="Logo Pride" />
          </div>
          <div className="formAge_title__container">
            <h1 className="formAge_title">
              Insira o número de participantes por faixa etária
            </h1>
            <div className="question__wrapper">
              <p className="text" onClick={toggleDropdown}>
                Por que essa pergunta?{' '}
                <img
                  className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                  src={cornerRightArrow}
                  alt="Saiba mais"
                />
              </p>
              <p className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}>
                Para ajustar planos e preços conforme faixa etária e
                necessidades de saúde.
              </p>
            </div>
          </div>
          <div className="formAge_fields__container">
            <div className="formAge_table__container">{renderTable()}</div>
          </div>
          <ProgressBar progress={progress} steps={5} />
        </section>
        <Footer />
      </AgeStyle>
    </>
  );
};

export default FormAge;
